
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import { Transporte } from '@/__env/lib/Expedicion/Transportes';
    import Axios from 'axios';
    import * as Pedidos from '@/__env/lib/Ventas/Pedidos';
    import { Envio } from '@/__env/lib/Ventas/Envios';
    import _ from 'lodash';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Utiles } from '@/__env/pluggins/event-bus';
import { Wait } from '@/__env/ext';
    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Seleccionados() { return this.Controlador.Seleccionados; }


        public get Estado() { return this.Controlador.Buscador.Estado; }



        Cerrar()
        {
            this.Seleccionados.clear();
        }

        public Cargando: boolean = false;
        public get Ok(): boolean
        {
            return this.Seleccionados.length > 0;
        }

        public get Seleccionada(): boolean
        {
            return this.Buscador.Filtros.Valores.HojaPiso > 0;
        }

        public async Ejecutar()
        {

            if ( ! await Utiles.Mensajes.SiNo( 'Crear hoja de piso', `¿Crear hoja de piso con los (${this.Seleccionados.length}) pedidos seleccionados?` ) )
                return;

            this.Cargando = true;
            Utiles.GenerandoArchivo( true );
            let pdf = await Pedido.URLHojaDePiso( this.Seleccionados );
            if ( pdf )
            {
                for ( let p of this.Seleccionados )
                {
                    p.Estado = Pedidos.Estados.Preparando;
                }
                await Wait( 100 );
                this.Controlador.RecargarEstadistica();
                window.open( pdf );
            } else
            {
                Utiles.Notificaciones.Error( `Error al generar la hoja de piso` );

            }
            Utiles.GenerandoArchivo( false);
            this.Cargando = false;
        }

        public async Descargar()
        {

            this.Cargando = true;
            Utiles.GenerandoArchivo( true );
            let pdf = await Pedido.URLHojaDePiso( this.Buscador.Filtros.Valores.HojaPiso );
            if ( pdf )
            {
                window.open( pdf );
            } else
            {
                Utiles.Notificaciones.Error( `Error al generar la hoja de piso` );

            }
            Utiles.GenerandoArchivo( false);
            this.Cargando = false;
        }
    }
